import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IonModal, IonSlides, LoadingController, ToastController} from '@ionic/angular';
import { LanguageService } from 'src/app/provider/language.service';
import {DefaultComponent} from "../../shared/components/default.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";

@Component({
  selector: 'app-onboarding-screen',
  templateUrl: './onboarding-screen.page.html',
  styleUrls: ['./onboarding-screen.page.scss'],
})
export class OnboardingScreenPage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  isLoading = false;
  authForm: FormGroup;


  constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
       toastController: ToastController
  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
  }

  ngOnInit() {
    this.authForm = this.fb.group({
      email: [''],
      password: ['']
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }
}
